<template>
  <custom-callout
    border-color="primary-2"
    class="bg-secondary-3 rounded mb-4 mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-2">
      <div class="d-flex row">
        <icon-view
          class="mt-md-0 mt-sm-5"
          icon="fas fa-file mb-1"
          icon-color="#ff7058"
          icon-size="16px"
          title="Crear Muestra"
        />
      </div>
      <validation-observer ref="sampleCardObserver">
        <div class="row my-2">
          <div class="col-md-3 col-sm-12">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.area"
                :custom-error-msg="'El área es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Área:"
                :options="areaOptions"
                placeholder="Seleccione"
                @input="onAreaChange"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.academicYear"
                :custom-error-msg="'El año es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Año Académico:"
                :options="academicYearOptions"
                placeholder="Seleccione"
                @input="onAcademicYearChange"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.semesterType"
                :custom-error-msg="'El semestre es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Semestre:"
                :options="semesterTypeOptions"
                placeholder="Seleccione"
                @input="onSemesterTypeChange"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12  pt-2 ">
            <div class="mt-4">
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mr-3 pl-3 pr-4"
                @click="onClose"
              />
              <action-button
                i="fas fa-arrow-alt-circle-right"
                text="Continuar"
                variant="success pl-3 pr-3"
                @click="onContinue"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'CreateSampleCard',
  components: {
    IconView,
    ActionButton,
    CustomDropDown,
    CustomCallout,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    academicYearOptions: {
      type: Array,
      default: () => [],
    },
    semesterTypeOptions: {
      type: Array,
      default: () => [],
    },
    areaOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        academicYear: null,
        semesterType: null,
        area: null,
      },
    };
  },
  methods: {
    onClose() {
      this.$emit('on-close');
    },
    async onContinue() {
      const isValid = await this.$refs.sampleCardObserver.validate();
      if (!isValid) return;
      this.$emit('on-continue', this.model);
    },
    onAcademicYearChange() {},
    onSemesterTypeChange() {},
    onAreaChange() {},
  },
};
</script>
